import React from 'react'
import { connect } from 'react-redux'

import Details from './Details'
import ErrorMessageCard from '../../../commons/ErrorMessageCard'

class LoanDetail extends React.Component {
  render() {
    const {
      canViewLoanSummary,
      primaryApplicantName,
    } = this.props

    return (
      <div className='card card-single'>
        <div className='card-header'>
          <div className='pull-right'>
            <a className='smaller' href='#' onClick={ () => this.props.onGoToClick('loan_setup')}>Edit</a>
          </div>
          Your loan
        </div>
        { canViewLoanSummary ?
          <Details />
          :
          <div className='card-body'>
            <ErrorMessageCard title='Loan setup is currently in progress'>
              <p>
                It seems like {primaryApplicantName} is still working on setting up the loan for your joint application.
              </p>
              <p>
                You can proceed with the rest of your application but you need to come back and review the loan setup once {primaryApplicantName} is done before you can submit the application.
              </p>
            </ErrorMessageCard>
          </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  canViewLoanSummary: state.loanApplicationUser.primary.canViewLoanSummary,
  primaryApplicantName: state.loanApplicationUser.primary.primaryApplicantName,
  loanDetail: state.review.loanDetail,
})

export default connect(mapStateToProps, {
})(LoanDetail)
